<template>
    <div>
        <DataTable :value="records" :lazy="true" :paginator="true" :rows="10" ref="dt" dataKey="id" :loading="loading"
            :totalRecords="totalRecords" @page="onPage($event)" @filter="onFilter($event)" :scrollable="true"
            scrollHeight="500px" :rowHover="true" showGridLines :class="['p-datatable--uk-trademarks']">

            <template #empty>
                No UK Trademarks found.
            </template>

            <template #loading>
                Loading UK Trademark data. Please wait.
            </template>

            <Column field="trademark_id" header="Trademark No."></Column>

            <column field="name" header="Name"></column>

            <Column field="status" header="Status">
                <template #body="{ data }">
                    {{ data.status }}
                </template>
            </Column>

            <Column field="classes" header="Classes">
                <template #body="{ data }">
                    <ul class="checker-search-results__class-list">
                        <li v-for="(classItem, index) in JSON.parse(data.classes)" :key="index"
                            class="checker-search-results__class-list-item">{{ classItem }}
                        </li>
                    </ul>
                </template>
            </Column>

            <Column field="url" header="URL">
                <template #body="{data}">
                    <a  target="_blank" :href="'https://trademarks.ipo.gov.uk' + data.url">Click here</a>
                </template>
            </Column>

        </DataTable>

        <template v-if="totalRecords > 0">
            <div class="creator-search-results__accordion-copy">
                {{ totalRecords }} UK Trademarks Found
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ApiMixin from "../../mixins/apiMixin";

const props = defineProps(['searchToken']);

const dt = ref();
const lazyParams = ref({});
const loading = ref(false);
const totalRecords = ref(0);
const records = ref(null);
// const definition = ref('');

let reloadInterval;

onMounted(async () => {
    lazyParams.value = {
        first: 0,
        rows: dt.value.rows
    };

    await loadLazyData();
});

// async function define(item) {

//     definition.value = 'Loading...'

//     let result = await ApiMixin.methods.searchTrademarkCategories(item.trim());

//     let theDefintion = result.map(function(i) {
//         return i['name'];
//     })

//     theDefintion = theDefintion.toString();

//     definition.value = theDefintion;
// }

async function onPage(event) {
    lazyParams.value = event;
    await loadLazyData();
}

async function loadLazyData() {
    clearInterval(reloadInterval);
    loading.value = true;
    const result = await ApiMixin.methods.ukTrademarkPaginate(props.searchToken, lazyParams.value);

    // EMPTY RECORD SET OR AN ERROR OCCURRED.
    if (!result) {
        records.value = [];
        totalRecords.value = 0;
        loading.value = false;
        return false;
    }

    records.value = result.data.results;

    // Reload table every 5 seconds if dataset incomplete and not on last page
    if (result.data.results < dt.value.rows && (lazyParams.value.page + 1) < lazyParams.value.pageCount)
        reloadInterval = setInterval(() => {
            loadLazyData();
        }, 5000)

    if (result.status == 200) {
        totalRecords.value = result.data.totalRecords;
        loading.value = false;
    }


}

</script>